import { DateTime } from 'luxon';
import React from 'react';
import { SubscriptionOption } from '../SubscriptionOptionDetails';
import SubscriptionOptionButton, {
  LifetimeSubscriptionContent,
  SubscriptionOverrideContent,
} from '../SubscriptionOptionDetails/SubscriptionOptionDetails';
import styles from './SubscriptionPill.module.scss';
import classNames from 'classnames';

export enum SubscriptionPillStyle {
  Default = 'default',
  Gray = 'gray',
  Downgrade = 'downgrade',
}

interface SubscriptionPillProps {
  subscriptionProduct: SubscriptionOption;
  renewalDate?: DateTime;
  expirationDate?: DateTime;
  pauseDate?: DateTime;
  disableSavingsDisplay?: boolean;
  style?: SubscriptionPillStyle;
  overrideTitle?: string;
  renewScreens?: boolean; // If these pills appear on renewal screens, styles will be slightly different.
  isPaused?: boolean; // If subscription is paused, pill will surface 'PAUSED' label and pause date
}
export default function SubscriptionPill({
  subscriptionProduct,
  renewalDate,
  expirationDate,
  pauseDate,
  disableSavingsDisplay,
  style,
  overrideTitle,
  renewScreens,
  isPaused,
}: SubscriptionPillProps) {
  let pillStyle = styles.pillDefault;
  if (style === SubscriptionPillStyle.Gray) {
    pillStyle = styles.pillGray;
  }
  if (style === SubscriptionPillStyle.Downgrade) {
    pillStyle = styles.pillDowngrade;
  }
  return (
    <div className={classNames(styles.pill, pillStyle)}>
      <SubscriptionOptionButton
        disableSavingsDisplay={disableSavingsDisplay}
        renewalDate={renewalDate}
        expirationDate={expirationDate}
        pauseDate={pauseDate}
        overrideTitle={overrideTitle}
        subscriptionProduct={subscriptionProduct}
        renewScreens={renewScreens}
        isPaused={isPaused}
      />
    </div>
  );
}

interface SubscriptionOverridePillProps {
  style?: SubscriptionPillStyle;
}
export function SubscriptionOverridePill({ style }: SubscriptionOverridePillProps) {
  let pillStyle = styles.pillDefault;
  if (style === SubscriptionPillStyle.Gray) {
    pillStyle = styles.pillGray;
  }
  if (style === SubscriptionPillStyle.Downgrade) {
    pillStyle = styles.pillDowngrade;
  }
  return (
    <div className={classNames(styles.pill, pillStyle)}>
      <SubscriptionOverrideContent />
    </div>
  );
}

export function LifetimeSubscriptionPill() {
  return (
    <div className={classNames(styles.pill, styles.pillGray)}>
      <LifetimeSubscriptionContent />
    </div>
  );
}
